export default __webpack_public_path__ + "static/media/email.b8107c75.png";